import { nextTick, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'

let widgetScript = null
let isWidgetLoaded = false

export function useWidget() {
  const route = useRoute()

  const connectWidget = (projectId = null) => {
    if (widgetScript && document.body.contains(widgetScript)) {
      return
    }

    window.SCRMprojectID = projectId
    window.SCRMuserToken = localStorage.getItem('access_token')

    widgetScript = document.createElement('script')
    widgetScript.src = `${process.env.VUE_APP_WIDGET_SCRM_SRC}?time=${new Date().getTime()}`
    widgetScript.async = true

    widgetScript.onload = () => {
      isWidgetLoaded = true
      if (window.wrgsv && typeof window.wrgsv.init === 'function') {
        window.wrgsv.init()
      }
    }

    document.body?.appendChild(widgetScript)
  }

  const updateWidgetProjectId = (projectId) => {
    if (window.SCRMprojectID !== projectId) {
      window.SCRMprojectID = projectId
      if (isWidgetLoaded && window.wrgsv && typeof window.wrgsv.init === 'function') {
        window.wrgsv.init()
      }
    }
  }

  onMounted(() => {
    const isProjectPage = route.name === 'project-by-id'
    const projectId = isProjectPage ? route.params?.id : null
    nextTick(() => {
      connectWidget(projectId)
    })
  })

  watch(
    () => route.name,
    (newRouteName) => {
      const isProjectPage = newRouteName === 'project-by-id'
      const projectId = isProjectPage ? route.params?.id : null
      updateWidgetProjectId(projectId)
    },
  )

  watch(
    () => route.params?.id,
    (newId) => {
      if (route.name === 'project-by-id') {
        updateWidgetProjectId(newId)
      } else {
        updateWidgetProjectId(null)
      }
    },
  )

  return {
    connectWidget,
    updateWidgetProjectId,
  }
}
